// extracted by mini-css-extract-plugin
module.exports = {"admin":"adminCategorys_admin__2g2AX","imgBackground":"adminCategorys_imgBackground__28E4H"};